import { GENDER_CONSTANTS, GenderConstant } from '@/constants/gender-constants.ts';

export const TEMPLATE_GENDER_CONSTANTS: Record<string, GenderConstant> = {
  ...GENDER_CONSTANTS,
  ALL: {
    label: 'All',
    value: 'A',
  },
};
